import React, { useEffect, useState } from 'react';

import '../assets/scss/rating.scss';
import { observer } from 'mobx-react';
import RatingStore from '../store/RatingStore';

function formatTime(time: string | undefined): string {
  if (time === null || time === undefined)
      return "-";

  let parts = time.split("T")[1].slice(0, time.split("T")[1].length-1).split(':');
  return parts[1] + ':' + parts[2];
}

function getScoreColor(score: number, maxScore: number) {
  const step = maxScore / 6;
  if (score >= maxScore - step * 4 + 1 && score <= maxScore - step * 3)
    return { color: '#1ce400', background: '#084a00' };
  else if (score >= maxScore - step * 3 + 1 && score <= maxScore - step * 2)
    return { color: '#ffc800', background: '#654f00' };
  else if (score >= maxScore - step * 2 + 1 && score <= maxScore - step * 1)
    return { color: '#ff6309', background: '#652703' };
  else if (score >= maxScore - step * 1 + 1)
    return { color: '#fe1f00', background: '#640b00' };
  else
    return { color: '#eeeeee', background: '#545454' };
}

const Rating: React.FC = observer(() => {
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched) {
      RatingStore.fetchMaps();
      RatingStore.fetchUsers();
      setFetched(true);
    }
  }, [fetched, setFetched]);

  return (
    <>
      <div className="rating">
        <div className="container">
          <div className="rating_inner">
            <table className="rating_table">
              <thead>
                <tr className="rating_table-header">
                  <th style={{ width: '128px' }}>Рейтинг</th>
                  <th>Игрок</th>
                  {RatingStore.maps.map((map, index) => {
                    return (
                      <th key={map.ID} style={{ width: '300px' }}>
                        {map.Title}
                        <br />
                        {index === 0 ?
                          <div className="difficulty-block">
                            <div className="difficulty easy" />
                          </div> :
                          <></>
                        }
                        {index === 1 ?
                          <div className="difficulty-block">
                            <div className="difficulty medium" />
                            <div className="difficulty medium" />
                          </div> :
                          <></>
                        }
                        {index === 2 ?
                          <div className="difficulty-block">
                            <div className="difficulty hard" />
                            <div className="difficulty hard" />
                            <div className="difficulty hard" />
                          </div> :
                          <></>
                        }
                      </th>
                    );
                  })}
                  <th style={{ width: '140px' }}>Очки</th>
                </tr>
              </thead>
            </table>
            <div className="table-body">
              <table className="rating_table">
                <tbody>
                  {RatingStore.users.map((user, index) => {
                    const colors = getScoreColor(user.Score, 15000);

                    return <tr className="rating_table-row" key={user.UserID.toString()}>
                      <td className="table_column-rank">{index+1}</td>
                      <td  className="table_column-name">{user.NickName !== '' ? user.NickName : user.ShortID}</td>
                      {RatingStore.maps.map((map) => {
                        const userMap = user.Maps.find(x => x.ID === map.ID);
                        return (
                          <td style={{ width: '300px' }} key={map.Title}>{formatTime(userMap?.Time)}</td>
                        );
                      })}
                      <td style={{ width: '140px' }}>
                        <div className="score" style={{ background: colors.background }}>
                          <div className="lines">
                            <div className="line" style={{ background: colors.color }} />
                            <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                          </div>
                          <div
                            className="value"
                            style={{
                              color: colors.color,
                              textWrap: 'nowrap'
                            }}
                          >
                            {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                          </div>
                        </div>
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default Rating;